import { useMutation } from 'react-query'
import request from '../../request'
import { useDealership } from '../../../store/zustand/dealershipStore'

export const useDeleteAIInsights = () => {
  const dealership = useDealership()
  return useMutation(() =>
    request({
      url: `/agencies/${dealership?.organization_id}/dealership/${dealership?.id}/campaigns/ai-insights`,
      method: 'DELETE',
    }),
  )
}
